module.exports = __webpack_public_path__ + "img/map-zs.539ebe65.png";